import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ComplexData from './ComplexData';
import ComplexChilds from './ComplexChilds';
import '../../../styles/ModalContent.css';
import { useState } from 'react';
import ComplexImages from './ComplexImages';
import ComplexGraphs from './ComplexGraphs';
import ComplexStatistic from './ComplexStatistic';
import ComplexCollage from './ComplexCollage';

const ModalContentCrossroad = props => {
    console.log(props)
    const { roles } = props
    const [key, setKey] = useState(roles?.includes('cafap_cr') ? 'collage' : 'home');
   
    return (
        <Tabs
            defaultActiveKey="profile"
            id="uncontrolled-tab-example"
            className="mb-3 modal_info_body_tabs"
            onSelect={(k) => setKey(k)}
            activeKey={key}

        >
            {roles && !roles.includes('cafap_cr') ?
                <Tab eventKey="home" title="Состав перекрестка">
                    <ComplexChilds childs={props.complex.child} isManager={roles.includes('manager')} />
                </Tab>
                : null
            }
            {roles && !roles.includes('cafap_cr') && !roles.includes('manager') ?
                <Tab eventKey="data" title="Данные">
                    <ComplexData complex={props.complex}/>
                </Tab>
                : null
            }
            {roles && !roles.includes('cafap_cr') && !roles.includes('manager') ?
                <Tab eventKey="graphs" title="Графики">
                    <ComplexGraphs complex={props.complex} />
                </Tab>
                : null
            }

            {roles && !roles.includes('cafap_cr') && !roles.includes('manager') ?
                <Tab eventKey="images" title="Кадры">
                    <ComplexImages complex={props.complex} style={props.style} />
                </Tab>
                : null
            }

            <Tab eventKey="statistic" title="Статистика">
                <ComplexStatistic complex={props.complex} style={props.style} />
            </Tab>

            <Tab eventKey="collage" title="Коллажи">
                <ComplexCollage complex={props.complex} />
            </Tab>
            {/* {
                ["codd", "uprdor", "camera_ovn" ].includes(props.complex.tags.find(tag => tag.tag === "type").value) ? 
                <Tab eventKey="stat" title="Статистика">
                    <ModalStat complex={props.complex}/>    
                </Tab>
                : null
            } */}

        </Tabs>
    )

}
export default ModalContentCrossroad